import moment from 'moment'

export default accountCtrl

/** @ngInject */
function accountCtrl(ApiService, User, $scope, userInfo, DeviceChecker, $uibModal, billingAddress, $state,
                     featuresService, BillingAddress, $rootScope, $window, DataAccessVariables, ContractStatus, AnonTermination, ErrorCatcher) {
    $scope.modifyBillAdd = false
    $scope.selectorBillAdd = false
    $scope.enableBtnSaveBillAdd = false
    $scope.showNewBillAddUnsave = false
    $scope.newBillAdd = ''
    $scope.sponsorFee = null
    $scope.sponsoredFee = null

    $scope.isTab = DeviceChecker.isTab
    $scope.isDesktop = DeviceChecker.isDesktop

    $scope.userBillingAddress = billingAddress
    $scope.userContract = userInfo.contractSelected

    $scope.startContractDate = userInfo.contractSelected.commissioning_date ? userInfo.contractSelected.commissioning_date : userInfo.contractSelected.retraction_end_date
    $scope.isRetractable = moment.utc().isBefore(userInfo.contractSelected.retraction_end_date)

    $scope.sponsorUrl = `${$window.location.origin}/parrainage/${userInfo.customer_id}`

    $scope.openRetractModal = () => {
        $uibModal.open({
            animation: true,
            size: 'md',
            controller: 'retractModalCtrl',
            template: require('./modal/retractModal.jade')(),
            resolve: {
                contractId() {
                    return $scope.userContract.id
                },
            },
        })
    }

    $scope.openSkipRetractModal = () => {
        $uibModal.open({
            animation: true,
            size: 'md',
            controller: 'skipRetractModalCtrl',
            template: require('./modal/skipRetractModal.jade')(),
            resolve: {
                contractId() {
                    return $scope.userContract.id
                },
            },
        })
    }

    $scope.openProofOfResModal = () => {
        $uibModal.open({
            animation: true,
            size: 'md',
            controller: 'proofOfResModalCtrl',
            template: require('../proofOfResModal/proofofresmodal.jade')(),
            resolve: {
                contractId() {
                    return $scope.userContract.id
                },
            },
        })
    }

    $scope.isUserContractCanRetract = () => ([ContractStatus.initial, ContractStatus.enAttenteEcheancier].indexOf(userInfo.contractSelected.status) > -1) && $scope.isRetractable

    $scope.isUserContractActive = () => userInfo.contractSelected.status === ContractStatus.enService

    $scope.canTerminate = () => [ContractStatus.enService, ContractStatus.coupe, ContractStatus.coupureDemande].indexOf($scope.userContract.status) > -1

    $scope.canDownloadContractCertificate = () => [
        ContractStatus.resilie,
        ContractStatus.duplicat,
        ContractStatus.retracte,
        ContractStatus.annule,
    ].indexOf($scope.userContract.status) === -1

    $scope.showInputBillAdd = () => {
        $scope.modifyBillAdd = !$scope.modifyBillAdd
    }

    $scope.refreshAddresses = function (search) {
        if (search !== '') {
            BillingAddress.showBillAddresses({ q: search }).$promise
            .then((response) => {
                $scope.billAddresses = response
            })
            .catch(ErrorCatcher.catchError)
        }
        if (search === '') {
            $scope.billAddresses = []
        }
    }

    $scope.selectLabel = function (element) {
        $scope.enableBtnSaveBillAdd = true
        $scope.showNewBillAddUnsave = true
        $scope.newBillAddSelected = element
    }

    $scope.cancelModifyBillAdd = function () {
        $scope.newBillAddSelected = ''
        $scope.billAddresses = ''
        $scope.showNewBillAddUnsave = false
        $scope.enableBtnSaveBillAdd = false
        $scope.modifyBillAdd = !$scope.modifyBillAdd
    }

    $scope.saveBillAdd = function (element) {
        const newBillAdd = {
            addr_city_code: element.addr_city_code,
            addr_city_lbl: element.addr_city_lbl,
            addr_num_street: element.addr_num_street,
            addr_post_code: element.addr_post_code,
            addr_details: element.addr_details,
            addr_locality: element.addr_locality,
            addr_bat: element.addr_bat,
        }
        return User.saveNewBillingAddress(newBillAdd).$promise
        .then((response) => {
            $scope.showNewBillAddUnsave = false
            return window.location.reload()
        }).catch(ErrorCatcher.catchError)
    }

    $scope.redirectToTerminate = () => {
        AnonTermination.createTerminationToken({ id_contract: $scope.userContract.id }, {}).$promise.then((tokenResult) => {
            $state.go('anonTerminationSummary', { tokenId: tokenResult.tokenId })
        }).catch((error) => {
            if (!error.message === 'transition prevented') {
                ErrorCatcher.catchErrorWithoutRedirect(error)
            }
        })
    }

    $scope.billingModalityMapper = {
        '2month': 'Bimestrielle',
        '6month': 'Semestrielle',
        '12month': 'Annuelle',
    }

    const activate = () => {
        DataAccessVariables.get({ variables: 'SPONSOR_FEE,SPONSORED_FEE' }).$promise
        .then((response) => {
            $scope.sponsorFee = response.SPONSOR_FEE
            $scope.sponsoredFee = response.SPONSORED_FEE
        })
    }

    activate()
}



// WEBPACK FOOTER //
// ./src/states/account/account.js